import React from 'react'
import { connect } from 'react-redux';

import {
  getLoanDetailInterestType
} from 'containers/LoanApplication/reducers';

import RepaymentType from './select/RepaymentType';
import InterestPeriod from './select/InterestPeriod';

class Variable extends React.Component {

  maybeRenderInterestPeriod() {
    const {
      interest,
      onChange,
    } = this.props;

    if (interest.variableRepaymentType == 'interest_only') {
      return(
        <InterestPeriod
          title="Select the interest period of your loan"
          checked={ interest.variableInterestPeriod }
          onChange={ (value) => onChange({ variableInterestPeriod: value }) }
        />
      )
    } else {
      return(null)
    }
  }

  render() {
    const {
      interest,
      onChange,
    } = this.props;

    return(
      <div>
        <RepaymentType
          checked={ interest.variableRepaymentType }
          onChange={ (value) => onChange({ variableRepaymentType: value }) }
        />
        { this.maybeRenderInterestPeriod() }
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  interest: getLoanDetailInterestType(state, 'variable')
})

export default connect(mapStateToProps)(Variable);
